import { UPDATE_EXPERIENCE } from './actionTypes';

export const updateExperience = data => ({
    type: UPDATE_EXPERIENCE,
    payload: data
});